import React, { useState, useEffect, useRef, useCallback } from "react";
import Helper from "./common/helper";
import Global from "./common/global";
import ApiService from "./services/api.service";
import Header from "./common/header";
import { Progress } from "flowbite-react";
import LoadingScreen from "./components/UI/loading-screen";
import StickyFooter from "./components/UI/sticky-footer";
// import ErrorComponent from './components/UI/error';
import ErrorComponent from "./components/errors/error-box";
// import { useFlags } from "launchdarkly-react-client-sdk";
import { loadingErrorHandler } from "./common/utils";
import {
  Router,
  useNavigate,
  Route,
  BrowserRouter,
  Routes,
  redirect,
  HashRouter,
  MemoryRouter,
} from "react-router";
import TagManager from "react-gtm-module";
import { phone } from "phone";
import hasPostalCode from "has-postalcode";
import Cookies from "js-cookie";

import {
  Phone,
  Title,
  Mail,
  User,
  State,
  Country,
  Postcode,
  City,
  Home,
  // Help,
} from "./common/icons";
import { commissionJunctionRules } from "./common/commission-junction-rules";

// Steps Component
import ProductStep from "./components/Steps/primary-product-step"; //[Primary] Product
import SecondaryProductStep from "./components/Steps/secondary-product-step"; //[Secondary] Product
import QbrEligibilityStep from "./components/Steps/qbr-eligibility-step";
import PersonalDetailStep from "./components/Steps/primary-personal-detail-step"; //[Primary] Details Step
import AddressStep from "./components/Steps/primary-address-step"; //[Primary] Address
import SecondaryPersonalDetailStep from "./components/Steps/secondary-personal-detail-step"; //[Secondary] Details Step
import SecondaryAddressStep from "./components/Steps/secondary-address-step"; //[Secondary] Address
import ReviewStep from "./components/Steps/review-step";
import PaymentStep from "./components/Steps/payment-step";
import ConfirmationStep from "./components/Steps/confirmation-step";
import ExploreStep from "./components/Steps/explore-step";
import CTA from "./components/UI/cta";
import Logo from "./components/logo";
import ErrorBoundary from "./components/errors/ErrorBoundary";
import { StepContainer } from "./components/UI/step-container";
import Payment from "./components/payment-component/payment";
import Login from "./components/Pages/login";
import Register from "./components/Pages/register";
import Renewal from "./components/Pages/renewal";
import ExpressCheckout from "./components/Pages/express-checkout";
import OAuthCallback from "./components/oauth";
import Transaction from "./components/Pages/transaction";
// import UserStep from './components/Steps/user-step';

// const TERMS_CONDITIONS_LINK = 'https://www.accorplus.com/en-au/about/terms-and-conditions';
let QBR_JOIN_ERROR_MESSAGE =
  'Something\'s not quite right and we\'re investigating. Please try again later. For assistance, contact the Qantas Business Rewards <a href="https://www.qantas.com/au/en/business-rewards/qbr/contactus" style="text-decoration-line:none" target="_blank">service desk</a>';

const callBackUrl =
  "wp-content/themes/accor-plus/modules/payment-portal/files/webapp-payments-release/callback";

TagManager.initialize({
  gtmId: Global.GTM_ID,
});

const App = ({ baseUrl }) => {
  const queryParams = new URLSearchParams(window.location.search);
  

  // Globals
  const [step, setStep] = useState(1); // Wizard Step state
  const [progress, setProgress] = useState(Helper.getProgressBarWidth(step)); // Progressbar State
  const [isProcessing, setIsProcessing] = useState(false); // Button Footer Sticky state
  const [error, setError] = useState(null);
  const [emailChecking, setEmailChecking] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false); // isLoading
  const [locationDatas, setLocationData] = useState([]); // get location Data - API
  const [allLanguages, setAllLanguages] = useState([]); // get all Languages - API
  const [translationKey, setTranslationKey] = useState("en");
  const [languages, setLanguages] = useState([]); // get Languages on the basis country id - API
  const [couponData, setCouponData] = useState([]); // get coupon Data
  const [isPrimaryDigitalCard, setIsPrimaryDigitalCard] = useState(false);
  const [isSecondaryDigitalCard, setIsSecondaryDigitalCard] = useState(false);
  const [headerText, setHeaderText] = useState("");
  const [isQbr, setIsQbr] = useState(false);
  const countryList = Global.CODED_COUNTRY_LIST.map((item) => {
    var country = item.name;
    var code = item.code;
    return {
      value: country,
      text: country,
      code: code,
    };
  });

  const selectedCountry = Helper.lookupCurrentCountry().label;

  // [Step] - Products
  const [products, setProducts] = useState([]); //product step
  const [isProductLoaded, setIsProductLoaded] = useState(false);
  const [isProductLoading, setIsProductLoading] = useState(true);
  const [productError, setProductError] = useState(null);

  // [Step] - Secondary Products
  const [secondaryProducts, setSecondaryMemberProducts] = useState([]);
  // const [isSecondaryMember, setIsSecondaryMember]       = useState(false)

  let locationDataCurrency = locationDatas.currency;

  // check membership product data
  const [isProductLocalStored, setIsProductLocalStored] = useState(false);

  // Local Storage State
  const [localStorageDatas, setLocalStorageDatas] = useState({});

  // Header modal
  const [showModal, setShowModal] = useState(false);

  // Member ID state - Confirm function
  const [memberId, setMemberId] = useState("");
  const [secondaryMemberId, setSecondaryMemberId] = useState("");

  const [memberCreationError, setMemberCreationError] = useState("");

  // SET businesscategories (BC)
  const [bc, setBC] = useState({});
  // Set BC that we get from membership api
  const [businessCategories, setBusinessCategories] = useState({});
  const inputPersonalEl = useRef([]);

  const inputAddressEl = useRef([]);
  const inputAddressBillingEl = useRef([]);

  // check if the input is touched
  const [touched, setTouched] = useState(false);

  // review-step refs
  const inputPromoEl = useRef([]);
  const readMeTerms = useRef(null);

  const [primaryPmid, setPrimaryPmid] = useState();
  const [hasAttemptedLoad, setHasAttemptedLoad] = useState(false);
  const [loadError, setLoadError] = useState("");

  // [Step] - Review Step
  function handleCardCheckBox(params, index, identifier) {
    let updatedProducts = localStorageDatas.members.map((item) => {
      if (
        item.type_of_member === params.type_of_member &&
        identifier === "primary"
      ) {
        setIsPrimaryDigitalCard(!item.card);
        return {
          ...item,
          card: !item.card,
        };
      } else if (
        item.type_of_member === params.type_of_member &&
        identifier === "supp"
      ) {
        setIsSecondaryDigitalCard(!item.card);
        return {
          ...item,
          card: !item.card,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setLocalStorageDatas((prevState) => ({
      ...prevState,
      ["members"]: updatedProducts,
    }));
  }

  function handleShowList(params, index) {
    let updatedProducts = localStorageDatas.members.map((item) => {
      if (item.type_of_member === params.type_of_member) {
        return {
          ...item,
          isShown: !item.isShown,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setLocalStorageDatas((prevState) => ({
      ...prevState,
      ["members"]: updatedProducts,
    }));
  }

  // [Step] - Review Order - CheckboxTerms
  const [checkBoxTerms, setCheckBoxTerms] = useState(false);
  // Added condition validation for checkbox
  const [checkboxError, setCheckboxError] = useState(false);
  const handleNextStep = (navigate) => {
    if (!checkBoxTerms) {
      setCheckboxError(true);
    } else {
      confirmOrder(navigate);
    }
  };
  function handleCheckBoxTerms() {
    setCheckBoxTerms(!checkBoxTerms);
    // setCheckboxError(!checkboxError)
  }

  // [Footer][Step]
  const [reviewLoading, setReviewLoading] = useState(false); // Review confirm Loading Button
  const [memberStatus, setMemberStatus] = useState(false); //

  // [Adress][Primary]
  // const [addressInput, setAddressInput]                  = useState({});
  // const [billingAddressInput, setBillingAddressInput]    = useState({});
  const [checkboxAddress, setCheckboxAddress] = useState(true);
  const [findMyaddessInGoogle, setFindMyaddessInGoogle] = useState(false);
  const [googleAddressEmpty, setGoogleAddressEmpty] = useState(false);
  const [subsidiary, setSubsidiary] = useState(0);

  // [Adress] - Primary
  const autoCompleteRef = useRef();
  const autoCompleteRef2 = useRef();
  const inputRef = useRef();
  const secondaryInputRef = useRef();
  const locationParam = Helper.locationSelect();

  //check if user is logged in
  const [isUserLogged, setIsUserLogged] = useState(false);
  const [loading, setLoading] = useState(true);

  // [Primary] Personal Details
  const personalDetailsInputFields = [
    // {
    //   name        : 'confirm_email',
    //   type        : 'email',
    //   placeholder : 'Confirm Email*',
    //   textHolder  : 'primaryConfirmEmail',
    //   icon        : Mail,
    //   required    : true,
    //   value       : '',
    //   message     :'',
    //   isError     : false,
    //   valid       : false,
    //   checking    : false
    // },
    {
      name: "title",
      type: "select",
      value: "Mr",
      placeholder: "Title*",
      textHolder: "primaryTitle",
      icon: Title,
      required: true,
      isError: false,
      message: "",
      valid: false,
      checking: false,
      options: Global.SALUTATION_LIST,
    },
    {
      name: "first_name",
      type: "text",
      maxLength: 25,
      placeholder: "First Name",
      textHolder: "primaryFirstName",
      icon: User,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
    },
    {
      name: "last_name",
      type: "text",
      placeholder: "Last Name",
      textHolder: "primaryLastName",
      maxLength: 25,
      icon: User,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "email",
      type: "email",
      placeholder: "Email",
      textHolder: "primaryEmail",
      icon: Mail,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "phone_number",
      type: "tel",
      placeholder: "Phone number*",
      textHolder: "phoneNumber",
      icon: Phone,
      required: true,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "postal_code",
      type: "text",
      placeholder: "Postal code",
      textHolder: "primaryShippingAddressPostcode",
      icon: Postcode,
      value: "",
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "state",
      type: "text",
      value: "",
      placeholder: "State",
      textHolder: "primaryShippingAddressState",
      required: false,
      icon: State,
      message: "",
      isError: false,
      valid: false,
      checking: false,
      // hidden: false,
    },
    {
      name: "country",
      type: "select",
      options: countryList,
      placeholder: "Country",
      textHolder: "primaryShippingAddressCountry",
      icon: Country,
      value: selectedCountry,
      required: true,
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "preferred_language",
      type: "select",
      options: Global.PREFERRED_LANGUAGE,
      placeholder: "Preferred language",
      textHolder: "preferredLanguage",
      icon: User,
      required: true,
      value: "en",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
    {
      name: "tax_number",
      type: "num",
      placeholder: "Tax Number",
      textHolder: "taxNumber",
      icon: Phone,
      required: false,
      value: "",
      message: "",
      isError: false,
      valid: false,
      checking: false,
    },
  ];

  // [Primary] Initialize Personal Details
  const [inputFields, setInputFields] = useState(personalDetailsInputFields);

  // [Secondary] Initialize Secondary Personal Details [2]
  // const [secondaryInputFields, setSecondaryInputFields] = useState(secondaryPersonalDetailsInputFields);

  function productInitialization() {
    const selectedMembership = sessionStorage.getItem("selected_membership");
    if (selectedMembership) {
      try {
        membershipCheck(selectedMembership);
      } catch (error) {
        console.error(
          "Invalid selected_membership data in sessionStorage:",
          error,
        );
      }
    }
  }

  function membershipCheck(product) {
    let convertedProduct;
    if (typeof product == "string") {
      convertedProduct = JSON.parse(product);
    } else {
      convertedProduct = product;
    }
    let membership;
    if (convertedProduct) {
      const item = convertedProduct[0].item_group_name;
      switch (item) {
        case "DISCOVERY MEMBERSHIP":
          membership = "discovery";
          break;
        case "EXPLORER MEMBERSHIP":
          membership = "explorer";
          break;
        case "EXPLORER PLUS MEMBERSHIP":
          membership = "explorer plus";
          break;
        default:
          membership = "";
          break;
      }
    }
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const currentProduct = url.searchParams.get("product");
    if (membership) {
      if (currentProduct !== membership) {
        searchParams.set("product", membership);
        window.history.replaceState(null, "", url.toString());
      }
    } else {
      if (searchParams.has("product")) {
        searchParams.delete("product");
        window.history.replaceState(null, "", url.toString());
      }
    }
  }

  // #cj state tracker
  let commissionJunction = "";
  // Fetch language Json
  console.log("loadError", { loadError });

  useEffect(() => {
    const init = async () => {
      try {
        setTouched(true);
        setProgress(Helper.getProgressBarWidth(step)); // optional: check if step should be a dependency

        ApiService.getIpAddress().then((data) => {
          console.log("browser_ip addr", data.customerIp);
          getIpData(data.customerIp);
        });

        await fetchLanguages();
        await fetchBenefitsTranslation();
        productInitialization();

        getLocalStorageDatas();
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoaded(true);
        console.log("App initialization completed.");
      }
    };
    init();
  }, []);



  // Set Header Title and Get Local Storage Data
  // update when step is changed
  useEffect(() => {
    var currentStep = Helper.getSteps(step);
    const title = Helper.getStepsTitle(currentStep, languages);
    setHeaderText(title);
    if (step <= 9) {
      getLocalStorageDatas();
    }
    setProgress(Helper.getProgressBarWidth(step));
  }, [step]);

  async function getIpData(ip) {
    // test ip outside aus `101.44.254.0`
    await ApiService.getDatafromIP(ip)
      .then((res) => res.json())
      .then((result) => {
        var country = Global.COUNTRY_LIST.filter(
          (x) => x.code === result.country.toLowerCase(),
        );

        if (country.length === 0) {
          country = Global.COUNTRY_LIST.filter((x) => x.code === "en");
        }
        setSubsidiary(country[0].subsidiary);
      });
  };
  const masterRegion = Helper.languageRegionSetter(locationParam);

  function setInputLanguages(setLanguage, input, translation, origin) {
    let region = masterRegion || "en_master";

    if (region !== "th" || region !== "id" || region !== "vn") {
      region = "en_master";
    }
    if (
      translation.length !== 0 &&
      allLanguages[region].selectYourMembership !== ""
    ) {
      let updatedPlaceholder = input.map((inputFields) => {
        if (inputFields.name === "phone_number") {
          return {
            ...inputFields,
            placeholder: translation[inputFields.textHolder] + "*",
          };
        } else if (inputFields.name) {
          return {
            ...inputFields,
            placeholder: translation[inputFields.textHolder],
          };
        } else {
          return {
            ...inputFields,
          };
        }
      });
      setLanguage(updatedPlaceholder);
      // setInputFields(updatedPlaceholder)
    }
  }

  /**
   * Checking if the user is logged in to the SSO
   */
  async function isSSOLoggedIn(locationDataParams) {
    let ssoUserData = await ApiService.userdata();
    let individualDetails = sortSsoUserData(ssoUserData);
    let ssoMemberEmail = individualDetails.email;

    if (Object.keys(ssoUserData).length > 0) {
      if (window.dataLayer.filter((a) => a.event === "general").length < 1) {
        TagManager.dataLayer(Helper.gtmGeneralPageData());
      }
      if (window.dataLayer.filter((a) => a.event === "userData").length < 1) {
        TagManager.dataLayer(
          Helper.gtmUserData(
            ssoUserData.card.currentTiering,
            ssoUserData.pmid,
            true,
          ),
        );
      }
    } else {
      if (window.dataLayer.filter((a) => a.event === "userData").length < 1) {
        TagManager.dataLayer(Helper.gtmUserData("", "", false));
      }
      if (window.dataLayer.filter((a) => a.event === "general").length < 1) {
        TagManager.dataLayer(Helper.gtmGeneralPageData());
      }
    }

    if (ssoMemberEmail) {
      setIsUserLogged(true);
      let isNotApMember = checkMemberIfAp(
        { email: ssoMemberEmail },
        true,
        locationDataParams.emailCheck,
      );
      // let isNotApMember = true;
      if (isNotApMember) {
        //populate personal details with SSO user data
        personalDetailsSubmitOverride({
          first_name: individualDetails.first_name || "",
          last_name: individualDetails.last_name || "",
          phone_number: individualDetails.phone_number,
          title: individualDetails.title,
          address_line_1: individualDetails.address_line_1,
          city: individualDetails.city,
          state: individualDetails.state,
          postcode: individualDetails.postcode,
          country: individualDetails.country,
          billing_address_line_1: individualDetails.billing_address_line_1,
          billing_city: individualDetails.billing_city,
          billing_country: individualDetails.billing_country,
          billing_state: individualDetails.billing_state,
          billing_postcode: individualDetails.billing_postcode || "",
          type_of_member: "primary_owner",
          email: ssoMemberEmail,
          pmid: individualDetails.pmid || "",
        });
        setPrimaryPmid(individualDetails.pmid);
      }
    } else {
      setIsUserLogged(false);
    }

    return false;
  }

  function salutationOverride(salutation) {
    switch (salutation) {
      case "DOC":
        return "Doctor";
      case "NA":
        return "Mr";
      case "MR":
        return "Mr";
    }

    return salutation;
  }

  function sortSsoUserData(ssoUserData) {
    let obj = {};
    if (ssoUserData) {
      obj["email"] = ssoUserData.email;
      obj["first_name"] = ssoUserData.firstName || ssoUserData.first_name;
      obj["last_name"] = ssoUserData.lastName || ssoUserData.last_name;
      obj["title"] = salutationOverride(ssoUserData.salutation);
      obj["pmid"] = ssoUserData.pmid;
      obj["address_line_1"] = ssoUserData.address.address1;
      obj["city"] = ssoUserData.address.city;
      obj["state"] = ssoUserData.address.state;
      obj["postcode"] = ssoUserData.address.zipCode;
      obj["country"] = ssoUserData.address.country;
      obj["billing_address_line_1"] = ssoUserData.address.address1;
      obj["billing_city"] = ssoUserData.address.city;
      obj["billing_country"] = ssoUserData.address.country;
      obj["billing_state"] = ssoUserData.address.state;
      obj["phone_number"] =
        ssoUserData.phone || ssoUserData.phonePrefix + ssoUserData.phoneNumber;
    }

    return obj;
  }

  async function checkMemberIfAp(params, redirect, apiKey) {
    let memberStatusResult = await ApiService.memberStatus(params, apiKey).then(
      (res) => res.json(),
    );

    if (memberStatusResult) {
      switch (memberStatusResult.status_text) {
        case "MEMBER-Current Member" || "MEMBER-In Progress":
          //redirect to renewal
          if (redirect) window.location = baseUrl + "renewals";
          break;
        case "MEMBER-Lapsed Member":
          //do not redirect but populate customer details
          return true;
      }
      return false;
    }
  }

  // [Primary] Personal Details Submit
  const personalDetailsSubmitOverride = (event) => {
    let input_data = event;
    const country = Global.CODED_COUNTRY_LIST.filter(
      (a) => a.name === primaryCountryOfSelection[0].value,
    );
    let addressDetails;

    const personalDetails = {
      email: input_data.email,
      title: input_data.title,
      first_name: input_data.first_name,
      last_name: input_data.last_name,
      phone_number: {
        leahNum: input_data.phone_number,
        inputVal: input_data.phone_number,
      },
      state: input_data.state,
      country: country[0]?.iso,
      postal_code: input_data.postcode,
    };
    sessionStorage.setItem("personal_details", JSON.stringify(personalDetails));

    getLocalStorageDatas();
  };

  function removeProduct(product) {
    setStep(1);
    if (product.type_of_member === "supp") {
      window.sessionStorage.removeItem("secondary_selected_membership");
      window.sessionStorage.removeItem("secondary_personal_details");
      window.sessionStorage.removeItem("secondary_address_details");
    }
    let updatedProducts = secondaryProducts.map((item) => {
      if (item.item_group_id === product.selected_product[0].item_group_id) {
        return {
          ...item,
          isSelected: false,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setSecondaryMemberProducts(updatedProducts);
  }

  // function isQbrEligible() {
  //   let selectedProduct = products.filter(x => x.isSelected === true);

  // }

  // Footer Button && Progressbar function
  function goNextStep(navigate) {
    // Check if region is QBR enabled and skip step if not.
    // QBR Step [3]
    const hasSelectedProduct = window.sessionStorage.getItem(
      "selected_membership",
    );
    let navigationStep = step;
    console.warn('navigate', navigate)

    if (step === 2 && !isQbr && !Helper.hotelDetected()) {
      setStep(3);
      navigationStep = 3;
    } else if (step === 1 && couponData.length > 0) {
      setStep(2);
      navigationStep = 2;
    } else if (step === 1 && Helper.hotelDetected()) {
      setStep(2);
      navigationStep = 2;
    } else if (step === 1 && isQbr) {
      console.log('Step QBR - Eligibility')
      setStep(10);
      navigationStep = 10;
    } else if (step === 10 && isQbr) {
      console.log('Step QBR - Personal Details')
      setStep(2);
      navigationStep = 2;
    } else if (step === 2 && isQbr) {      
      console.log('Step QBR - Review')
      setStep(3);
      navigationStep = 3;
    } else if (step === 3 && isQbr) {
      console.log('Step QBR - Payment')
      setStep(4);
      navigationStep = 4;
    } else if (step === 1 && hasSelectedProduct) {
      setStep(2);
      navigationStep = 2;
    } else {
      setStep(step + 1);
      navigationStep = step + 1;
    }

    if (navigate)
      navigate({
        pathname: Helper.navigate(navigationStep),
      });

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  // Footer Button && Progressbar function
  function goPreviousStep(navigate) {
    // Check if region is QBR enabled and skip step if not.
    // QBR Step [3]
    let navigationStep = step;
    if (step === 4 && !isQbr && !Helper.hotelDetected()) {
      setStep(3);
      navigationStep = 1;
    } else if (step === 4 && couponData.length > 0) {
      setStep(3);
      navigationStep = 1;
    } else if (step === 4 && Helper.hotelDetected()) {
      setStep(3);
      navigationStep = 1;
    } else if (step === 3) {
      setStep(2);
      navigationStep = 1;
    } else if (step === 2 && isQbr) {
      setStep(10);
      navigationStep = 1;
    } else if (step === 10 && isQbr) {
      setStep(1);
      navigationStep = 1;
    } else {
      setStep(step - 1);
      navigationStep = step - 1;
    }
    const path = window.location.search + Helper.navigate(navigationStep);
    if (navigate) navigate(-1);
  }

  function productsForGtm() {
    let products = [];
    if (localStorageDatas.members[0].selected_product[0] !== undefined) {
      for (let i = 0; i < localStorageDatas.members.length; i++) {
        let item_selected = localStorageDatas.members[i].selected_product;
        var getCoupon = Helper.checkCoupon(item_selected[0], couponData);
        let member = localStorageDatas.members[i];
        products.push({
          item_id: member.selected_product[0].item_group_id,
          item_name: member.selected_product[0].item_group_description,
          price:
            parseFloat(member.selected_product[0].purchase_price) +
            parseFloat(
              member.selected_product[0].tax_amt ||
              member.selected_product[0].tax_amount,
            ),
          coupon: getCoupon.exists ? getCoupon.coupon_code_id : "No coupon",
          affiliation: "Accor Plus",
          currency: member.selected_product[0].currency_text,
          discount: getCoupon.exists ? getCoupon.total : 0.0,
          index: i,
          item_brand: "Accor Plus",
          item_category: member.selected_product[0].item_group_name,
          location_id: locationDatas.subsidiary,
          quantity: 1,
        });
      }
      return products;
    }
  }

  //Payment Process Transaction ID
  const processPayment = (
    transactionId,
    subscriptionTransaction,
    paymentType,
    navigate,
  ) => {
    if (
      window.dataLayer.filter((a) => a.event === "begin_checkout").length < 1
    ) {
      TagManager.dataLayer(
        Helper.gtmBeginCheckout(
          locationDatas.currency,
          window.location.pathname,
          productsForGtm(),
        ),
      );
      commissionJunction = commissionJunctionRules(locationDatas, paymentType);
    }
    const payment_data = {
      ...localStorageDatas,
      transactionId: transactionId,
      subscriptionTransaction: subscriptionTransaction,
      paymentType: paymentType,
    };
    setLocalStorageDatas(payment_data);
    goNextStep(navigate);
    console.log("redirecting to confirmation");

    // or we can add everything here.
  };

  // [Step] - Review
  async function confirmOrder(navigate) {
    setReviewLoading(true);
    let payloadObj = {};
    let payload = [];
    let child_of = "";

    for (let [index, member] of localStorageDatas.members.entries()) {
      setReviewLoading(true);
      let businessCategoryObj;
      if (Object.keys(member.selected_product).length !== 0) {
        businessCategoryObj =
          localStorageDatas.business_categories[
          member.selected_product[0].business_category_id
          ];
      }
      payloadObj = {
        subsidiary: businessCategoryObj.subsidiary,
        location: businessCategoryObj.location_id,
        department: businessCategoryObj.department_id,
        salutation: member.title,
        memberid: member.memberid ? member.memberid : "",
        firstname: member.first_name,
        lastname: member.last_name,
        email: member.email,
        phone1_type: null,
        phone1: member.phone_number?.countryCodeValLeading0
          ? member.phone_number.countryCodeValLeading0.toString()
          : "",
        leah_phone: member.phone_number?.countryCodeValLeading0
          ? member.phone_number.countryCodeValLeading0.toString()
          : "",
        prefix: member.phone_number.dialCode,
        home_addr1: member.address_line_1,
        home_addr2: member.address_line_2,
        home_addr3: member.address_line_3,
        home_zip: member.postcode,
        home_city: member.city,
        home_country: member.country,
        home_state: member.state
          ? member.state
          : member.primaryShippingAddressState,
        ship_addr1: member.billing_address_line_1,
        ship_addr2: member.billing_address_line_2,
        ship_addr3: member.billing_address_line_3,
        ship_zip: member.billing_postcode,
        ship_city: member.billing_city,
        ship_country: member.billing_country,
        ship_state: member.billing_state,
        referrer_name: "",
        hotel_last_stay: "",
        source: Helper.hotelDetected() ? "Hotel" : "Website",
        partner_ref_number: partnerRefNumber,
        preferred_language: member.preferred_language
          ? member.preferred_language
          : "en",
      };
      // if(member.type_of_member == "supp") {
      //   payloadObj["child_of"] = child_of;
      // }

      payload.push(payloadObj);

      let params = {
        abn: partnerRefNumber,
        accountManagerDetails: {
          title: member.title,
          firstName: member.first_name,
          lastName: member.last_name,
          emailAddress: member.email,
          mobile: {
            countryCode: member.phone_number.dialCode,
            number: member.phone_number.localNumber,
          },
        },
      };

      let result_member_id;

      if (member.type_of_member == "primary_owner") {
        // if(Helper.isQbr() && isQBRnewMember && partnerRefNumber){
        // setReviewLoading(true);
        if (
          (Helper.isQbr(locationDatas) || member.selected_product[0]?.isQbr) &&
          partnerRefNumber
        ) {
          qbrJoinApi(params, index, payloadObj, payload, member, navigate);
          // const result_member_id = await memberApi(index, payloadObj, payload, member);
        } else {
          result_member_id = await memberApi(
            index,
            payloadObj,
            payload,
            member,
          );
          setReviewLoading(false);
        }
        // child_of = result_member_id;
      }

      //localStorageDatas.members[index].memberid = result_member_id;
      //getLocalStorageDatas();
    }
    setReviewLoading(false);
    if (!partnerRefNumber) { //if its QBR
      goNextStep(navigate);
    } else {
      redirect("/payment");
    }
  }

  async function memberApi(payloadIndex, memberPayload, payload, member) {
    let memberid = "";
    const queryParams = new URLSearchParams(window.location.search);
    let hotelRIDOnlineKiosk = queryParams.get("hotelRIDOnlineKiosk");
    let apHotelEmployeeName = queryParams.get("apHotelEmployeeName");
    let hotelEmployee = queryParams.get("hotelEmployee");
    let hotelSalesDefaultBC = locationDatas.hotelSalesData;

    function getMemberCreateError(country, code) {
      var msg;

      if (hotelRIDOnlineKiosk && apHotelEmployeeName && hotelEmployee) {
        let bc = hotelSalesDefaultBC.find((c) => c.country == code);
        let redirectBC =
          bc === undefined
            ? hotelSalesDefaultBC.find((c) => c.country == "en")
            : bc;
        msg = `Our records show that you are registered in ${country}. Would you like to switch to <a href="/${code}/registration/?redirect=F&bc=${redirectBC.hotelSalesDefaultBC}&hotelRIDOnlineKiosk=${hotelRIDOnlineKiosk}&apHotelEmployeeName=${apHotelEmployeeName}&hotelEmployee=${hotelEmployee}" style="display: inline;text-decoration: underline;">${country}</a>? Otherwise, please contact <a target="_blank" href='https://accorplushelp.zendesk.com/hc/en-au' style="display: inline;text-decoration: underline;"> Member Services</a> to complete your transaction.`;
      } else {
        msg = `Our records show that you are registered in ${country}. Would you like to switch to <a href="/${code}/registration/?redirect=F" style="display: inline;text-decoration: underline;">${country}</a>? Otherwise, please contact <a target="_blank" href='https://accorplushelp.zendesk.com/hc/en-au' style="display: inline;text-decoration: underline;"> Member Services</a> to complete your transaction.`;
      }

      setMemberCreationError(msg);
    }
    if (localStorageDatas.members[payloadIndex]["memberid"]) {
      if (memberPayload["subsidiary"]) {
        memberPayload["subsidiary"] = null;
      }
      await ApiService.memberUpdate(memberPayload)
        .then((res) => res.json())
        .then(
          (result) => {
            if (member.type_of_member == "primary_owner") {
              memberid = result.memberid;

              if (result.errorMessage) {
                setMemberCreationError(
                  `ErrCode (1016) : Not updated correctly. Check your details and try again.`,
                );
                setReviewLoading(false);
                throw "ERROR";
              }

              //lookup subsidiary
              let subResult = subsidiaryLookup(result.subsidiary);
              if (!subResult.found) {
                //not matching subsidiary so send error message
                getMemberCreateError(subResult.country, subResult.code);
                setReviewLoading(false);
                throw "ERROR";
                //return;
              }
            }
            if (result.errorMessage) {
              console.error("ERROR", result.errorMessage);
              setMemberCreationError(result.errorMessage);
            }
          },
          (error) => {
            console.error("error", error);
          },
        );
    } else {
      await ApiService.memberCreate(memberPayload)
        .then((res) => res.json())
        .then(
          (result) => {
            if (member.type_of_member === "primary_owner") {
              setMemberId(result.memberid);
            } else if (member.type_of_member === "supp") {
              setSecondaryMemberId(result.memberid);
            }
            localStorageDatas.members[payloadIndex]["memberid"] =
              result.memberid;

            if (member.type_of_member == "primary_owner") {
              memberid = result.memberid;

              //lookup subsidiary
              let subResult = subsidiaryLookup(result.subsidiary);
              console.log("subresult", subResult);
              if (result.errorMessage) {
                setMemberCreationError(
                  `ErrCode (1015) : Not registered correctly. Check your details and try again.`,
                );
                setReviewLoading(false);
                throw "ERROR";
              }

              if (!subResult.found) {
                //not matching subsidiary so send error message
                // setMemberCreationError(`Our records show that you are registered in ${subResult.country}. Would you like to switch to <a href="/${subResult.code}/registration/?redirect=F" style="display: inline;text-decoration: underline;">${subResult.country}</a>? Otherwise, please contact <a target="_blank" href='https://accorplushelp.zendesk.com/hc/en-au' style="display: inline;text-decoration: underline;"> Member Services</a> to complete your transaction.`);
                getMemberCreateError(subResult.country, subResult.code);
                setReviewLoading(false);
                throw "ERROR";
                //return;
              }
            }
            if (result.errorMessage) {
              console.error("ERROR", result.errorMessage);
              setMemberCreationError(result.errorMessage);
            }
          },
          (error) => {
            console.error("error", error);
          },
        );
    }
    return memberid;
  }

  async function qbrValidation(
    result,
    index,
    payloadObj,
    payload,
    member,
    navigate,
  ) {
    let child_of = "";
    if (typeof result === "object") {
      if (result.errorMessage) {
        let errMsg =
          result.fieldErrorMessages[0]?.errorMessage || result.errorMessage;
        if (
          result.errorCode === "ABN_ALREADY_REGISTERED" ||
          result.errorCode === "EMAIL_ALREADY_REGISTERED" ||
          result.errorCode === "ENTITY_ALREADY_EXISTS"
        ) {          
          setMemberCreationError("");
          let result_member_id = await memberApi(
            index,
            payloadObj,
            payload,
            member,
          );
          child_of = result_member_id;
          setReviewLoading(false);
          goNextStep(navigate);
        } else {
          // (result.errorMessage === "Invalid request payload - invalid request body")
          setMemberCreationError(errMsg);
          setReviewLoading(false);
          throw "ERROR";
        }
      } else if (result.status === "ACTIVE" || result.status === "active") {          
          setMemberCreationError("");
          let result_member_id = await memberApi(
            index,
            payloadObj,
            payload,
            member,
          );
          child_of = result_member_id;
          setReviewLoading(false);
          goNextStep(navigate);
      } else {
        setMemberCreationError(error.fieldErrorMessages[0].errorMessage);
      }
    } else {
      setMemberCreationError(QBR_JOIN_ERROR_MESSAGE);
      setReviewLoading(false);
      throw "ERROR";
    }
  }

  async function qbrJoinApi(params, index, payloadObj, payload, member, navigate) {
    await ApiService.qbrJoin(params)
      .then((res) => res.json())
      .then(
        (result) => {
          qbrValidation(result, index, payloadObj, payload, member, navigate);
        },
        (error) => {
          if (
            error &&
            error.responseJSON.fieldErrorMessages &&
            error.responseJSON.fieldErrorMessages[0].errorMessage
          ) {
            setMemberCreationError(error.fieldErrorMessages[0].errorMessage);
          } else {
            setMemberCreationError(QBR_JOIN_ERROR_MESSAGE);
          }
          setReviewLoading(false);
          throw "ERROR";
        },
      );
    return;
  }

  function subsidiaryLookup(subsidiary) {
    if (locationDatas.subsidiary == subsidiary) {
      let country = Helper.lookupSubsidiaryCountry(subsidiary);
      return {
        subsidiary: subsidiary,
        found: true,
        country: country.label,
        code: country.code,
      };
    }
    let country = Helper.lookupSubsidiaryCountry(subsidiary);
    return {
      subsidiary: subsidiary,
      found: false,
      country: country.label,
      code: country.code,
    };
  }

  // Header Text title
  function setHeaderStepText(steps, language) {
    var currentStep = Helper.getSteps(steps);
    const title = Helper.getStepsTitle(currentStep, language);
    setHeaderText(title);
  }

  function getGtmProduct(product, index) {
    let products = [];
    if (product !== null) {
      var member = product;
      let item_selected = member[0]; // check
      var getCoupon = Helper.checkCoupon(item_selected, couponData);

      products.push({
        item_id: item_selected.item_group_id,
        item_name: item_selected.item_group_description,
        price:
          parseFloat(item_selected.purchase_price) +
          parseFloat(item_selected.tax_amt || item_selected.tax_amount),
        coupon: getCoupon.exists ? getCoupon.coupon_code_id : "No coupon",
        affiliation: "Affiliation name/Accor plus",
        currency: item_selected.currency_text,
        discount: getCoupon.exists ? getCoupon.total : 0.0,
        index: index,
        item_brand: "Accor Plus",
        item_category: item_selected.item_group_name,
        location_id: locationDatas.subsidiary,
        quantity: 1,
      });
    }
    return products;
  }

  // Membersip Localstorage store
  function storeMembershipData(navigate) {
    // if (identifier === 1) {
    let selectedProduct = products.filter((x) => x.isSelected === true);
    let isProductSelectedQBR = products.filter((x) => x.isQbr === true);

    var prevProd = JSON.parse(sessionStorage.getItem("selected_membership"));
    if (prevProd !== null) {
      if (selectedProduct[0]?.item_group_id !== prevProd[0]?.item_group_id) {
        // both aren't equal, remove the
        TagManager.dataLayer(
          Helper.gtmEcommerceCart(
            "remove_from_cart",
            "primary",
            getGtmProduct(prevProd, 0),
          ),
        );
        TagManager.dataLayer(
          Helper.gtmEcommerceCart(
            "add_to_cart",
            "primary",
            getGtmProduct(selectedProduct, 0),
          ),
        );
      }
    } else {
      TagManager.dataLayer(
        Helper.gtmEcommerceCart(
          "add_to_cart",
          "primary",
          getGtmProduct(selectedProduct, 0),
        ),
      );
    }
    sessionStorage.setItem(
      "selected_membership",
      JSON.stringify(selectedProduct),
    );
    membershipCheck(selectedProduct);
    goNextStep(navigate);
    // }

    // else if (identifier === 2) {
    //   let secondarySelectedProduct = secondaryProducts.filter(x => x.isSelected === true);
    //   var prevProd = JSON.parse(sessionStorage.getItem('secondary_selected_membership'));
    //   if(secondarySelectedProduct !== null && prevProd === null) {
    //     TagManager.dataLayer(Helper.gtmEcommerceCart('add_to_cart_two', 'supp', getGtmProduct(secondarySelectedProduct, 1)))
    //     TagManager.dataLayer(Helper.gtmGeneralCheckoutStep('checkoutstep_two', getPath(step), step))
    //   }
    //   sessionStorage.setItem('secondary_selected_membership', JSON.stringify(secondarySelectedProduct));
    //   goNextStep();
    // }
  }

  // Button Product - Membership Selection
  function selectMembership(e) {
    let updatedProducts = products.map((item) => {
      if (
        item.item_group_id === e.item_group_id &&
        item.item_group_description === e.item_group_description
      ) {
        return {
          ...item,
          isSelected: true,
        };
      } else {
        return { ...item, isSelected: false };
      }
    });
    // add a cart
    setProducts(updatedProducts);
    // Check if product is qbr eligible
    if (
      (e.isQbr !== undefined && e.isQbr === true) ||
      Helper.isQbr(locationDatas)
    ) {
      setIsQbr(true);
    } else {
      setIsQbr(false);
    }
  }

  const [benefitsTranslations, setBenefitsTranslation] = useState({});

  const fetchBenefitsTranslation = async () => {
    let region = masterRegion || "au";

    try {
      const response = await ApiService.getBenefits();
      const result = await response.json();

      const data = {
        ...result,
        region,
      };

      setBenefitsTranslation(data);
    } catch (error) {
      loadingErrorHandler(loadError, "1040", setLoadError);
      setError(error);
      return Promise.reject(error);
    }
  };

  const fetchLanguages = async () => {
    console.log("Fetching languages...");
    try {
      const region = masterRegion || "au";
      const response = await ApiService.getLanguages();
      const result = await response.json();

      setAllLanguages(result);

      const regionLanguage = getRegionLanguage(result, region);
      setLanguages(regionLanguage);
      // setLocalLanguage(result);
      fetchLocationData(locationParam);
    } catch (error) {
      console.error("Languages fetch error:", error);
      setError(error);
      loadingErrorHandler(loadError, "1043", setLoadError);
      return Promise.reject(error);
    }
  };

  function setLocalLanguage(data, region, regionLanguage) {
    if (data) {
      if (window.location.href.includes("localhost")) {
        regionLanguage = data[region] ?? data["en_master"];
        setTranslationKey(data[region] ? region : "en");
      } else {
        const languagePathMap = {
          th: "/th/th/",
          au: "/au/",
          vn: "/vn/vi/",
          id: "/id/id/",
        };

        if (window.location.pathname.startsWith(languagePathMap[region])) {
          regionLanguage = data[region];
          setTranslationKey(region);
        } else {
          regionLanguage = data["en_master"];
          setTranslationKey("en");
        }
      }
    }
  }

  // Extracted helper function
  const getRegionLanguage = (data, region) => {
    if (!data) return null;

    let regionLanguage = data["en_master"]; // default fallback
    const pathname = window.location.pathname;

    for (const [key, value] of Object.entries(data)) {
      if (key.indexOf(region) > -1) {
        if (window.location.href.includes("localhost")) {
          if (["th", "vn", "id"].includes(key)) {
            regionLanguage = value;
          } else {
            regionLanguage = data["en_master"];
          }
        } else {
          if (
            (key === "th" && pathname === "/th/th/registration/") ||
            (key === "vn" && pathname === "/vn/vi/registration/") ||
            (key === "id" && pathname === "/id/id/registration/")
          ) {
            regionLanguage = value;
          } else {
            regionLanguage = data["en_master"];
          }
        }
      }
    }

    setLocalLanguage(data, region, regionLanguage)
    return regionLanguage;
  };

  // [Primary] Main Address
  // const addressInputDetails = [
  //   {
  //     name: "address_line_1",
  //     type: "text",
  //     value: "",
  //     maxLength: 32,
  //     placeholder: "Address Line 1*",
  //     textHolder: "primaryBillingAddressLine1",
  //     icon: Home,
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "address_line_2",
  //     type: "text",
  //     value: "",
  //     maxLength: 32,
  //     placeholder: "Address Line 2",
  //     textHolder: "primaryBillingAddressLine2",
  //     icon: Home,
  //     required: false,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "address_line_3",
  //     type: "text",
  //     value: "",
  //     maxLength: 32,
  //     placeholder: "Address Line 3",
  //     textHolder: "primaryBillingAddressLine3",
  //     icon: Home,
  //     required: false,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "city",
  //     type: "text",
  //     value: "",
  //     placeholder: "City*",
  //     textHolder: "primaryBillingAddressCity",
  //     icon: City,
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "state",
  //     type: "text",
  //     value: "",
  //     placeholder: "State",
  //     textHolder: "primaryBillingAddressState",
  //     required: false,
  //     icon: State,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "postcode",
  //     type: "text",
  //     value: "",
  //     placeholder: "Postcode",
  //     textHolder: "secondaryBillingAddressPostcode",
  //     icon: Postcode,
  //     required: false,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "country",
  //     type: "select",
  //     options: countryList,
  //     value: selectedCountry,
  //     placeholder: "Country*",
  //     textHolder: "secondaryBillingAddressCountry",
  //     icon: Country,
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  // ];

  // [Primary] Billing / Shipping Address
  // const billingAddress = [
  //   {
  //     name: "billing_address_line_1",
  //     type: "text",
  //     maxLength: 32,
  //     placeholder: "Shipping Address Line 1*",
  //     textHolder: "primaryShippingAddressLine1",
  //     icon: Home,
  //     value: "",
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "billing_address_line_2",
  //     type: "text",
  //     maxLength: 32,
  //     placeholder: "Shipping Address Line 2",
  //     textHolder: "primaryShippingAddressLine2",
  //     icon: Home,
  //     value: "",
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "billing_address_line_3",
  //     type: "text",
  //     maxLength: 32,
  //     placeholder: "Shipping Address Line 3",
  //     textHolder: "primaryShippingAddressLine3",
  //     icon: Home,
  //     value: "",
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "billing_city",
  //     type: "text",
  //     placeholder: "City*",
  //     textHolder: "primaryShippingAddressCity",
  //     icon: City,
  //     value: "",
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "billing_state",
  //     type: "text",
  //     placeholder: "State",
  //     textHolder: "primaryShippingAddressState",
  //     required: false,
  //     icon: State,
  //     value: "",
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "billing_postcode",
  //     type: "number",
  //     placeholder: "Postcode*",
  //     textHolder: "primaryShippingAddressPostcode",
  //     icon: Postcode,
  //     value: "",
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  //   {
  //     name: "billing_country",
  //     type: "select",
  //     options: countryList,
  //     placeholder: "Country*",
  //     textHolder: "primaryShippingAddressCountry",
  //     icon: Country,
  //     value: selectedCountry,
  //     required: true,
  //     message: "",
  //     isError: false,
  //     valid: false,
  //     checking: false,
  //   },
  // ];

  //Main Address
  // const [primaryAddressInputFields, setPrimaryAddressInputFields] = useState(personalDetailsInputFields);
  const primaryCountryOfSelection = inputFields.filter(
    (a) => a.name === "country",
  );

  const [isPrimaryPostalRequired, setIsPrimaryPostalRequired] = useState(true);

  //Primary Main Address


  const handleOnUpdateAddress = async (
    paramsName,
    locParams,
    countryParams,
    setIsPostal,
  ) => {
    setIsPostal(hasPostalCode(countryParams[0]?.iso)); // returns true or false post code
    let isPostalCountryRequired = hasPostalCode(countryParams[0]?.iso);

    await ApiService.getLocationData(locParams)
      .then((res) => res.json())
      .then(
        (result) => {
          const isStateReq =
            result === null
              ? false
              : result.stateRequired === undefined
                ? false
                : result.stateRequired === true
                  ? true
                  : false;
          if (result && result.stateRequired && result.states) {
            let state = result.states.map((item) => {
              return { value: item, text: item };
            });
            let storedAddressData = inputFields.map((item) => {
              if (item.name === paramsName) {
                return {
                  ...item,
                  type: "select",
                  options: state,
                  placeholder:
                    isStateReq === true
                      ? languages.primaryShippingAddressStateRequired
                        ? languages.primaryShippingAddressStateRequired
                        : "State*"
                      : languages.primaryShippingAddressState
                        ? languages.primaryShippingAddressState
                        : "State",
                  textHolder: "primaryShippingAddressStateRequired",
                  required: true,
                  isError: false,
                  message: "",
                  value: "",
                };
              }
              if (item.name === "postal_code") {
                return {
                  ...item,
                  required: isPostalCountryRequired,
                  placeholder: isPostalCountryRequired
                    ? languages.primaryShippingAddressPostcode
                    : languages.primaryShippingAddressPostcodeNonReq,
                  isError: false,
                  message: "",
                };
              } else {
                return {
                  ...item,
                };
              }
            });
            setInputLanguages(
              setInputFields,
              storedAddressData,
              languages,
              "location_data 2",
            );
          } else {
            let storedAddressData = inputFields.map((item) => {
              if (item.name === paramsName) {
                return {
                  ...item,
                  type: "text",
                  placeholder:
                    isStateReq === true
                      ? languages.primaryShippingAddressStateRequired
                        ? languages.primaryShippingAddressStateRequired
                        : "State*"
                      : languages.primaryShippingAddressState
                        ? languages.primaryShippingAddressState
                        : "State",
                  textHolder: "primaryShippingAddressState",
                  required: isStateReq,
                  isError: false,
                  message: "",
                  value: "",
                };
              }
              if (item.name === "postal_code") {
                return {
                  ...item,
                  required: isPostalCountryRequired,
                  placeholder: isPostalCountryRequired
                    ? languages.primaryShippingAddressPostcode
                    : languages.primaryShippingAddressPostcodeNonReq,
                  isError: false,
                  message: "",
                };
              } else {
                return {
                  ...item,
                };
              }
            });
            setInputLanguages(
              setInputFields,
              storedAddressData,
              languages,
              "location_data",
            );
          }
        },
        (error) => {
          console.error(error);
          // setError(error);
        },
      );
  };

  const fetchLocationData = async (locParams) => {
    setIsPrimaryPostalRequired(
      hasPostalCode(primaryCountryOfSelection[0].value),
    );
    // setIsSecondaryPostalRequired(hasPostalCode(secondaryCountryOfSelection[0].value))
    await ApiService.getLocationData(locParams)
      .then((res) => {
        console.log("Location Data Response:", res);
        if (!res.ok) {
          loadingErrorHandler(loadError, "1041", setLoadError);
          return res.json();
        }
        return res.json()
      })
      .then(
        (result) => {
          console.log("Location Data Response result:", result)
          setLocationData(result);
          isSSOLoggedIn(result);
          sessionStorage.setItem("location_data", JSON.stringify(result));

          productData(result);
          getStoredProductData(products, "selected_membership", "primary");
          getStoredProductData(
            secondaryProducts,
            "secondary_selected_membership",
            "secondary",
          );

          if (result && result.stateRequired && result.states) {
            let state = result.states.map((item) => {
              return { value: item, text: item };
            });
            let storedAddressData = inputFields.map((item) => {
              if (item.name === "state") {
                return {
                  ...item,
                  type: "select",
                  options: state,
                  placeholder: languages.primaryBillingAddressState
                    ? languages.primaryBillingAddressState + "*"
                    : "State*",
                  required: true,
                };
              }
              if (item.name === "postcode") {
                return {
                  ...item,
                  placeholder: languages.primaryBillingAddressPostcode
                    ? languages.primaryBillingAddressPostcode + "*"
                    : "Postcode*",
                  required: isPrimaryPostalRequired,
                };
              } else {
                return {
                  ...item,
                };
              }
            });
            setInputLanguages(
              setInputFields,
              storedAddressData,
              languages,
              "fetchLocData",
            );
          }
          // isSSOLoggedIn()
        },
        (error) => {
          setError(error);
          loadingErrorHandler(loadError, "1041", setLoadError);
          return Promise.reject(error);
        },
      );
  };

  // [QBR][Step]
  const eligibilityCheckInputFields = [
    {
      name: "abn",
      type: "number",
      placeholder: languages.qbrAbn ? languages.qbrAbn : "ABN*",
      icon: User,
      required: false,
      value: "",
    },
    {
      name: "email",
      type: "email",
      placeholder: languages.qbrEmail ? languages.qbrEmail : "Email*",
      icon: Mail,
      required: false,
      value: "",
    },
  ];
  const [QBRinput, setQBRInput] = useState(eligibilityCheckInputFields);
  const [isQBRnewMember, setIsQBRnewMember] = useState(false);
  const [isQBRError, setisQBRError] = useState(false);
  const [QBRmessage, setQBRMessage] = useState("");
  const [showQBRTerms, setQBRTerms] = useState(false);
  const inputQBREligibilityEl = useRef([]);
  const [QBRLoading, setQBRLoading] = useState(false);
  const [partnerRefNumber, setPartnerRefNumber] = useState("");
  const [checkBoxTermsQBR, setCheckBoxTermsQBR] = useState(false);
  const [checkBoxConsentQBR, setCheckBoxConsentQBR] = useState(false);
  const [checkBoxContactInfoQBR, setCheckBoxContactInfoQBR] = useState(false);
  const [showCheckBoxTermsTermsError, setShowCheckBoxTermsTermsError] =
    useState(false);

  function handleCheckBoxTermsQBR() {
    setCheckBoxTermsQBR(!checkBoxTermsQBR);
  }

  function handleCheckBoxConsentQBR() {
    setCheckBoxConsentQBR(!checkBoxConsentQBR);
  }

  function handleCheckBoxContactInfoQBR() {
    setCheckBoxContactInfoQBR(!checkBoxContactInfoQBR);
  }

  function inputQBRChange(e) {
    var name = e.target.name;
    var value = e.target.value;
    let storedData = QBRinput.map((input) => {
      if (input.name === name) {
        return {
          ...input,
          value: value,
        };
      } else {
        return {
          ...input,
        };
      }
    });
    setQBRInput(storedData);
  }

  function qbrValidate() {
    const qbrData = window.sessionStorage.getItem("qbr_details");
    function qbrValidator(params) {
      if (qbrData === null || qbrData === undefined) {
        return null;
      } else {
        let inputQbr = QBRinput.find((x) => x.name === `${params}`).value;
        let storageQbr = JSON.parse(qbrData)[`${params}`];
        return inputQbr === storageQbr;
      }
    }
    if (!(qbrValidator("abn") && qbrValidator("email"))) {
      setCheckBoxTermsQBR(false);
      setQBRTerms(false);
      setQBRMessage("");
      return false;
    } else {
      return true;
    }
  }

  //validate qbr function
  const validateQbr = () => {
    qbrValidate();

    // e.preventDefault()
    if (showQBRTerms && !checkBoxTermsQBR) {
      setShowCheckBoxTermsTermsError(true);
      return;
    } else {
      setShowCheckBoxTermsTermsError(false);
    }
    setQBRLoading(true);
    let payload = {
      abn: QBRinput[0].value,
      email: QBRinput[1].value,
    };
    sessionStorage.setItem("qbr_details", JSON.stringify(payload));

    if (payload.abn && payload.email) {
      ApiService.qbrEligible(payload)
        .then((res) => res.json())
        .then(
          (result) => {
            if (result && result == "EMAIL_ALREADY_REGISTERED") {
              setisQBRError(true);
              setQBRTerms(false);
              setIsQBRnewMember(false);
              setQBRMessage(
                languages.qbrValidateEmailErrorMessage
                  ? languages.qbrValidateEmailErrorMessage
                  : 'It looks like the email address you entered is already registered with Qantas Business Rewards. Please enter a different email address or contact the <a href="https://www.qantas.com/au/en/business-rewards/qbr/contactus" target="_blank">Qantas Business Rewards service desk</a>.',
              );
            } else if (result && result == "INVALID_INPUT_PARAMETER") {
              setisQBRError(true);
              setQBRTerms(false);
              setIsQBRnewMember(false);
              setQBRMessage(
                languages.qbrValidateAbnErrorMessage
                  ? languages.qbrValidateAbnErrorMessage
                  : 'It looks like there is an error with your ABN. Please provide a different ABN or contact the <a href="https://www.qantas.com/au/en/business-rewards/qbr/contactus" target="_blank">Qantas Business Rewards service desk</a> for assistance.',
              );
            } else if (result && result == "ABN_ALREADY_REGISTERED") {
              // setisQBRError(true);
              // setQBRTerms(false);
              setisQBRError(false);
              setQBRTerms(true);
              setQBRMessage(
                languages.qbrEligibleSuccessMessage
                  ? languages.qbrEligibleSuccessMessage
                  : "Great news! Your business is already a Qantas Business Rewards member and is eligible to earn Qantas Points with Accor Plus. <br />By proceeding, you will be joining Accor Plus. Please agree to below the Terms and Conditions and click Next to continue.",
              );
              setIsQBRnewMember(false);
            } else {
              setisQBRError(false);
              setQBRMessage(
                languages.qbrDisclaimerMessage
                  ? languages.qbrDisclaimerMessage
                  : "By proceeding, you will be joining Accor Plus and Qantas Business Rewards. After completing your registration, your business will receive 10,000 Qantas Points on Accor Plus Business Explorer Membership.<br />Please agree to below the Terms and conditions and click Next to continue completing the registration form.",
              );
              setQBRTerms(true);
              setIsQBRnewMember(true);
            }
            setQBRLoading(false);
          },
          (error) => {
            if (error) {
              setQBRTerms(false);
              setQBRMessage(error);
            } else {
              setQBRMessage(
                languages.qbrServerErrorMessage
                  ? languages.qbrServerErrorMessage
                  : "Something went wrong. Please try again later or contact Member Services.",
              );
            }
            setQBRTerms(true);
            setQBRLoading(false);
          },
        );
    } else {
      setisQBRError(true);
      setQBRMessage(
        languages.qbrValidationEmptyFieldMessage
          ? languages.qbrValidationEmptyFieldMessage
          : "The above fields are mandatory and must be filled.",
      );
      setQBRTerms(false);
      setQBRLoading(false);
    }
  };

  const confirmValidateQBR = (navigate) => {
    if (
      !QBRLoading &&
      checkBoxTermsQBR &&
      checkBoxConsentQBR &&
      checkBoxContactInfoQBR &&
      qbrValidate()
    ) {
      if (QBRinput[1].value) {
        let storedData = inputFields.map((inputFields) => {
          if (inputFields.name === "email") {
            return {
              ...inputFields,
              value: QBRinput[1].value,
            };
          } else {
            return {
              ...inputFields,
            };
          }
        });
        setInputLanguages(setInputFields, storedData, languages, "QBR confirm");
        setShowCheckBoxTermsTermsError(false);
        setPartnerRefNumber(QBRinput[0].value);
        goNextStep();
        // goNextStep(navigate);
      } else {
        setisQBRError(true);
        setQBRMessage(
          languages.qbrValidateCheckboxErrorMessage
            ? languages.qbrValidateCheckboxErrorMessage
            : "Something went wrong. Please try again.",
        );
      }
    } else {
      setisQBRError(true);
      setTimeout(() => {
        setQBRMessage(
          languages.qbrValidateCheckboxErrorMessage
            ? languages.qbrValidateCheckboxErrorMessage
            : "Something went wrong. Please try again.",
        );
      }, 1000);
    }
  };

  // Get Stored Product data if available
  const getStoredProductData = async (params, storageVariable, string) => {
    const productData = window.sessionStorage.getItem(storageVariable);

    if (productData !== null) {
      let storedProducts = await params.map((item) => {
        if (item.item_group_id === JSON.parse(productData)[0].item_group_id) {
          return {
            ...item,
            isSelected: true,
          };
        }
        return item;
      });
      if (string === "primary") {
        setProducts(storedProducts);
      } else if (string === "secondary") {
        setSecondaryMemberProducts(storedProducts);
      }
      setIsProductLocalStored(true);
    }
  };

  // Get Product Data
  const productData = async (locationResult) => {
    let bc = locationResult.defaultPriceLevel;
    let pricelevel = null;
    let subsidiary = locationResult.subsidiary;
    const isDBS = Helper.isDBS();
    let couponCheck = false;
    let couponErrorMessage = "";
    var memberAssistanceMail =
      '<a href = "mailto: members.singapore@accorplus.com" style="text-decoration:underline;">Member Services</a>';
    var currentMember = false;

    let ui_channel = null;

    if (document.cookie) {
      let json;
      json = document.cookie.split("; ").reduce((prev, current) => {
        const [name, ...value] = current.split("=");
        prev[name] = value.join("=");
        return prev;
      }, {});
      if (json.coupon) {
        var couponObj = JSON.parse(json.coupon);
        setCouponData(couponObj);
        if (couponObj.coupon_code_valid && !couponObj.coupon_code_used) {
          subsidiary = couponObj.subsidiary_id;
          bc = couponObj.business_category_id;
        }
      }
    }

    if (!isProductLocalStored) {
      bc = queryParams.get("bc") ? queryParams.get("bc") : bc;
      pricelevel = queryParams.get("pricelevel")
        ? queryParams.get("pricelevel")
        : pricelevel;
      ui_channel = queryParams.get("ui_channel")
        ? queryParams.get("ui_channel")
        : "";

      if (isDBS.status) {
        //check if URL has coupon and email to confirm it's DBS
        await ApiService.memberStatus(
          { email: isDBS.email },
          locationResult.emailCheck,
        )
          .then((res) => res.json())
          .then(
            (result) => {
              if (
                isUserLogged &&
                result.status_text === "MEMBER-Current Member"
              ) {
                currentMember = true;
              } else {
                currentMember = false;
                couponCheck = false;
              }
            },
            (error) => {
              setError(error);
            },
          );
      }

      if (!currentMember) {
        if (
          (queryParams.get("email") && queryParams.get("coupon")) ||
          queryParams.get("coupon")
        ) {
          await ApiService.getCouponData({ code: queryParams.get("coupon") })
            .then((res) => res.json())
            .then(
              (result) => {
                if (result === null) {
                  couponCheck = true;
                  couponErrorMessage = `We can’t seem to proceed… Please refresh the page and try again. If you require further assistance, please contact our ${memberAssistanceMail} team.`;
                  return;
                } else {
                  var couponObj = JSON.parse(result);
                  if (!couponObj.coupon_code_valid) {
                    // by default it's true check if coupon code is valid or not
                    couponCheck = true;
                    var validCouponUrl =
                      '<a  style="text-decoration:underline;" target=”_blank” href="https://dbswebprv-sg-p02.corp.dbs.com/flp-contact/dbs/cards/dbs-vantage-accor-registration/default.page">here</a>';
                    couponErrorMessage = `We can’t seem to proceed… Our record shows that the email address provided is not valid. Register for DBS Vantage Visa Infinite Card – Accor Plus Explorer membership ${validCouponUrl}.`;
                  } else if (couponObj.coupon_code_used) {
                    // by default it's false: check if coupon code is already used.
                    couponCheck = true;
                    couponErrorMessage = `We can’t seem to proceed… Please contact our ${memberAssistanceMail} team for further assistance.`;
                  } else {
                    subsidiary = couponObj.subsidiary_id;
                    bc = couponObj.business_category_id;
                  }
                  setCouponData(result);
                  sessionStorage.setItem("coupon_data", JSON.stringify(result));
                }
              },
              (error) => {
                // add a string checker: ErrCode (1004)
                setError(error);
              },
            );
        }
      } else {
        couponCheck = true;
        couponErrorMessage = `We can’t seem to proceed… Our record shows that you are currently logged in as a member. Please log out and try again. If you require further assistance, please contact our ${memberAssistanceMail} team.`;
      }
      await ApiService.getProducts(bc, subsidiary, null, pricelevel, ui_channel)
        .then((res) => {
          console.log("getProducts", res);
          if (!res.ok) {
            setIsProductLoading(false);
            setIsProductLoaded(false);
          }
          return res.json();
        })
        .then(
          (result) => {
            if (result === null) {
              setProductError("No Memberships available.");
              setIsProductLoaded(true);
              return;
            }

            if (result?.errorMessage) {
              setProductError("Error: " + result.errorMessage);
            } else {
              //Filter products depending on the scenario
              if (couponCheck) {
                setProductError(couponErrorMessage);
                setIsProductLoaded(true);
                return;
              }

              const businessCategoryId =
                result.item_groups[0]?.business_category_id;
              const businessCategoriesList = Object.values(
                result.business_categories,
              );
              const salesTypeId = businessCategoriesList.find(
                (businessCategories) =>
                  businessCategories.business_category_id ===
                  businessCategoryId,
              ).sales_type_id;
              const businessProperties = [
                { salesTypeId },
                ...businessCategoriesList,
              ];
              sessionStorage.setItem(
                "businessProperties",
                JSON.stringify(businessProperties),
              );

              setBC(result.business_categories);
              setBusinessCategories(result.business_categories);
              if (ui_channel) {
                bc = null;
                pricelevel = null;
              }
              const filteredProducts = Helper.filterProducts(
                bc,
                pricelevel,
                result,
                locationResult,
              );
              const standaloneProducts = result.item_groups.filter(
                (x) => x.non_standalone,
              );

              setProductError("");
              setError("");
              //setProducts(result.item_groups);
              setProducts(filteredProducts);
              setSecondaryMemberProducts(standaloneProducts);
              if (
                result.item_groups.length > 0 &&
                result.item_groups[0].currency_text &&
                locationResult.currency
              ) {
                let locationDataCurrency = locationResult.currency;
                let productCurrency = result.item_groups[0].currency_text;
                if (locationDataCurrency != productCurrency) {
                  setProductError(
                    languages.merchantMatchErrorMessagePurchase
                      ? languages.merchantMatchErrorMessagePurchase
                      : "You cannot purchase in " +
                        locationResult.currency +
                        ". " +
                        languages.merchantMatchErrorMessageLink
                        ? languages.merchantMatchErrorMessageLink
                        : "Merchant not available. Please <a href='contact' style='display: contents;'>contact Member Services</a> for more information.",
                  );
                }
              }
            }
            setIsProductLoading(false);
            setIsProductLoaded(true);
          },
          (error) => {
            console.log("getProductserror", error)
            setIsProductLoading(false);
            setIsProductLoaded(false);
            setProductError(error);
            loadingErrorHandler(loadError, "1042", setLoadError);
          },
        );
    }
  };

  // Load saved Localstorage if exists
  const getLocalStorageDatas = () => {
    const productData = window.sessionStorage.getItem("selected_membership");
    if (productData !== null)
      var storageLocalProductData = JSON.parse(productData);

    const personalData = window.sessionStorage.getItem("personal_details");

    if (personalData !== null) {
      var storageLocalPersonalData = JSON.parse(personalData);
      let storedData = inputFields.map((inputFields) => {
        if (inputFields.name) {
          return {
            ...inputFields,
            value: storageLocalPersonalData[inputFields.name],
          };
        }
      });
      // setInputFields(storedData)
      setInputLanguages(
        setInputFields,
        storedData,
        languages,
        "localStorageData",
      );
      // goNextStep()
      // setpersonalDetailsInput(JSON.parse(personalData));
    }

    if (storageLocalProductData) {
      const partnerLeadId = queryParams.get("leadid");
      const localstorageData = {
        business_categories: { ...bc },
        members: [
          {
            selected_product: { ...storageLocalProductData },
            ...storageLocalPersonalData,
            type_of_member: "primary_owner",
            memberid: partnerLeadId || memberId,
            card: isPrimaryDigitalCard,
            isShown: true,
            pmid: primaryPmid || "",
          },
        ],
        hotelRIDOnlineKiosk: queryParams.get("hotelRIDOnlineKiosk")
          ? queryParams.get("hotelRIDOnlineKiosk")
          : "",
        apHotelEmployeeName: queryParams.get("apHotelEmployeeName")
          ? queryParams.get("apHotelEmployeeName")
          : "",
        hotelEmployee: queryParams.get("hotelEmployee")
          ? queryParams.get("hotelEmployee")
          : "",
        apHotelEmployeeId: queryParams.get("apHotelEmployeeId")
          ? queryParams.get("apHotelEmployeeId")
          : "",
        source: Helper.hotelDetected() ? "Hotel" : "Website",
        step,
      };
      setLocalStorageDatas(localstorageData);
    }
  };

  // Edit Button Review Step
  function editReview(item) {
    if (item.type_of_member === "primary_owner") {
      setStep(1);
    } else if (item.type_of_member === "supp") {
      setStep(2);
    }
    setProgress(Helper.getProgressBarWidth(step));
    setHeaderStepText();
  }

  // Header modal
  function handleShowModal(e) {
    e.preventDefault();
    setShowModal(true);
  }

  // Header modal
  function onCloseModal() {
    setShowModal(false);
  }

  // Inputs Fields Validation Check
  // For Both Primary and Secondary Members
  function onFieldBlur(e) {
    const name = e.target.name;
    const value = e.target.value;
    let message;
    let error;
    let valid;
    let checking;
    if (name === "email") {
      if (!value) {
        message = languages.validateEmail
          ? languages.validateEmail
          : "Please enter your email address";
        error = true;
      } else {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
          message = languages.validateEmail
            ? languages.validateEmail
            : "Please enter a valid email address.";
          error = true;
          valid = false;
        } else {
          valid = false;
          error = false;
          if (touched === true) {
            checking = true;
            checkMemberExist({ email: value });
            setEmailChecking(true);
          }
        }
      }
    }
    if (name === "first_name" || name === "last_name") {
      const hasOnlyLetters = !!value.match(/^[a-zA-Z_'-. ]*$/i);
      if (!value && name === "first_name") {
        message = languages.validateFirstName
          ? languages.validateFirstName
          : "Please enter your first name";
        error = true;
      } else if (!value && name === "last_name") {
        message = languages.validateLastName
          ? languages.validateLastName
          : "Please enter your last name";
        error = true;
      } else if (!hasOnlyLetters) {
        message = languages.fieldContainsLatinCharactersMessage
          ? languages.fieldContainsLatinCharactersMessage
          : "Please enter only latin characters";
        error = true;
      } else {
        var validation = Helper.characterLimit(name, value);
        if (!validation) {
          message = languages.validateCharacters
            ? languages.validateCharacters
            : "This field must not exceed 25 characters.";
          error = true;
        } else {
          message = "";
          error = false;
          valid = true;
        }
      }
    }
    if (name === "title") {
      message = "";
      error = false;
      valid = true;
    }

    if (name === "postal_code") {
      if (!value && getPostalCodeValues()[0].required) {
        message = languages.validatePostalCode
          ? languages.validatePostalCode
          : "Please enter your postal code";
        error = true;
        valid = false;
      } else {
        message = "";
        error = false;
        valid = true;
      }
    }

    if (name === "state") {
      if (!value || value === "State") {
        message = languages.validateState
          ? languages.validateState
          : "Please enter your state";
        error = true;
        valid = false;
      } else {
        message = "";
        error = false;
        valid = true;
      }
    }

    if (name === "country") {
      if (!value || value === "Country") {
        message = languages.validateCountry
          ? languages.validateCountry
          : "Please enter your country";
        error = true;
        valid = false;
      } else {
        message = "";
        error = false;
        valid = true;
      }
    }

    let validationCheckedFields = inputFields.map((item) => {
      if (item.name === name) {
        if (item.name === "email" && item.isError && !checking) {
          return {
            ...item,
          };
        } else {
          return {
            ...item,
            isError: error,
            message: message,
            checking: checking,
            valid: valid,
          };
        }
      } else {
        return {
          ...item,
        };
      }
    });
    setInputLanguages(
      setInputFields,
      validationCheckedFields,
      languages,
      "onfieldBlur",
    );
  }

  // [Primary] Personal Details Submit [5]
  const personalDetailsSubmit = (navigate) => {
    let isValid = true;
    let memberCheck;
    const message = languages.fieldMissingErrorMessage
      ? languages.fieldMissingErrorMessage
      : "This field is mandatory and must be filled out.";
    if (inputFields === null) {
      isValid = false;
      memberCheck = inputFields.map((item) => {
        if (item.name === "title") {
          return {
            ...item,
            isError: false,
            message: "",
          };
        } else {
          return {
            ...item,
            isError: true,
            message: message,
            valid: false,
          };
        }
      });
    } else {
      var email;
      // var confirmEmail;
      inputFields.map((item) => {
        if (item.name === "email" && item.value) {
          email = item.value;
        }
      });
      memberCheck = inputFields.map((item) => {
        if (item.name === "first_name" && !item.value) {
          return {
            ...item,
            isError: true,
            message: "Please enter your first name",
          };
        } else if (item.name === "last_name" && !item.value) {
          return {
            ...item,
            isError: true,
            message: "Please enter your last name",
          };
        } else if (item.name === "email" && !item.value) {
          return {
            ...item,
            isError: true,
            message: "Please enter your email address",
          };
        } else if (
          item.name === "state" &&
          (item.value === "State" || item.value === "") &&
          item.required
        ) {
          return {
            ...item,
            isError: true,
            message: "Please enter your state",
          };
        } else if (
          item.name === "postal_code" &&
          !item.value &&
          item.required
        ) {
          return {
            ...item,
            isError: true,
            message: "Please enter your postal code",
          };
        } else if (item.name === "country" && !item.value) {
          return {
            ...item,
            isError: true,
            message: "Please enter your country",
          };
        } else if (item.name === "country" && item.value === "Country") {
          return {
            ...item,
            isError: true,
            message: "Please enter your country",
          };
        } else if (item.name === "phone_number" && !item.value) {
          return {
            ...item,
            isError: true,
            message: languages.validatePhone
              ? languages.validatePhone
              : "This field must contain a valid phone number",
          };
        } else if (
          item.name === "phone_number" &&
          item.value.leahNum &&
          item.value.leahNum.length < 10
        ) {
          return {
            ...item,
            isError: true,
            message: languages.validatePhone
              ? languages.validatePhone
              : "This field must contain a valid phone number",
          };
        } else if (item.isError) {
          return {
            ...item,
          };
        } else {
          return {
            ...item,
            isError: false,
            message: "",
          };
        }
      });
    }

    inputFields.map((item) => {
      if (item.isError) {
        isValid = false;
      }
    });

    let personalArr = [];
    let storedData = inputFields.map((inputFields) => {
      if (inputFields.name) {
        return {
          name: inputFields.name,
          value: inputFields.value,
          required: inputFields.required,
        };
      }
    });

    personalArr.push(storedData);
    var input_data = {};
    for (var i = 0; i < personalArr[0].length; i++) {
      input_data[personalArr[0][i].name] = personalArr[0][i].value;
      input_data["state_required"] = personalArr[0].find(
        (item) => item.name === "state",
      )?.required;
      input_data["postal_required"] = personalArr[0].find(
        (item) => item.name === "postal_code",
      )?.required;
    }
    if (
      !isValid ||
      (input_data.state_required ? input_data.state === "" : "") ||
      inputFields === null ||
      input_data.email === "" ||
      (input_data.postal_required ? input_data.postal_required === "" : "") ||
      input_data.country === "" ||
      input_data.country === "Country" ||
      input_data.country === undefined ||
      input_data.state === "State" ||
      input_data.state === undefined ||
      input_data.first_name === "" ||
      input_data.last_name === "" ||
      input_data.phone_number === "" ||
      input_data.phone_number.leahNum === "" ||
      input_data.phone_number.leahNum.length < 10
    ) {
      // setInputFields(memberCheck);
      setInputLanguages(
        setInputFields,
        memberCheck,
        languages,
        "personal detail submit",
      );
    } else {
      sessionStorage.setItem("personal_details", JSON.stringify(input_data));
      TagManager.dataLayer(
        Helper.gtmGeneralCheckoutStep(
          "checkoutstep_three",
          Helper.navigate(step),
          3,
        ),
      );
      // goNextStep(navigate);

      goNextStepOrRedirect(navigate);
    }
  };

  function getPostalCodeValues() {
    var primaryCountryOfSelection = inputFields.filter(
      (a) => a.name === "country",
    );
    const primaryCountry = Global.CODED_COUNTRY_LIST.filter(
      (a) => a.name === primaryCountryOfSelection[0].value,
    );
    let allowedCodes = [
      "nz",
      "au",
      "in",
      "id",
      "my",
      "sg",
      "ph",
      "th",
      "vn",
      "hk",
    ];
    let countryCode = primaryCountry[0].code.toLowerCase();
    let postalCodeRules = Global.POSTAL_CODE_LIST.filter((item) => {
      if (allowedCodes.includes(countryCode)) {
        return item.code === countryCode;
      } else {
        return item.code === "row";
      }
    });
    return postalCodeRules;
  }

  // const { enableCheckoutModule, refundWidgetToggle } = useFlags();
  const [isStepProcessing, setIsStepProcessing] = useState(false);

  const getLanguage = () => {
    if (
      inputFields.find((f) => f.name === "preferred_language").value.length > 0
    ) {
      return inputFields.find((f) => f.name === "preferred_language").value;
    }
    return "en";
  };

  const goNextStepOrRedirect = async (navigate) => {
    if (!queryParams.get("coupon") && !isQbr) {
      setIsStepProcessing(true);

      const selectedMembership = window.sessionStorage.getItem(
        "selected_membership",
      );

      if (!selectedMembership) {
        setIsStepProcessing(false);
        throw new Error("No selected membership found in session storage.");
      }

      const productData = JSON.parse(
        window.sessionStorage.getItem("selected_membership"),
      );

      const selectedProduct =
        productData.filter((product) => product.isSelected)[0] || products[0];

      const country = Global.CODED_COUNTRY_LIST.filter(
        (a) => a.name === inputFields.find((f) => f.name === "country").value,
      );

      const locationParam = Helper.locationSelect();

      try {
        let HOTEL_DETECTED = false;

        if (localStorageDatas.hotelRIDOnlineKiosk) {
          HOTEL_DETECTED = true;
        }

        const payload = {
          translationKey,
          salesRegion: locationParam.country.toUpperCase(),
          productLanguage: getLanguage(),
          businessCategoryId: selectedProduct.business_category_id,
          productId: couponData?.item_group_id ?? selectedProduct.item_group_id,
          customer: {
            firstName: inputFields.find((f) => f.name === "first_name").value,
            lastName: inputFields.find((f) => f.name === "last_name").value,
            title: inputFields.find((f) => f.name === "title").value,
            email: inputFields.find((f) => f.name === "email").value,
            postCode: inputFields.find((f) => f.name === "postal_code").value,
            preferredLanguage: getLanguage(),
            country: country[0].code,
            state: inputFields.find((f) => f.name === "state")?.value,
            phoneNumber: inputFields.find((f) => f.name === "phone_number")
              .value.phoneNumber,
            taxNumber: inputFields.find((f) => f.name === "tax_number")?.value,
            pmId: primaryPmid,
          },
          attribution: {
            hotelRIDOnlineKiosk: localStorageDatas.hotelRIDOnlineKiosk,
            apHotelEmployeeName: localStorageDatas.apHotelEmployeeName,
            hotelEmployee: localStorageDatas.hotelEmployee,
            apHotelEmployeeId: localStorageDatas.apHotelEmployeeId,
            commissionJunctionRules: commissionJunctionRules(
              locationDatas,
              "juspay",
            ).replace("#", ""),
          },
          source: localStorageDatas.source,
          couponId: couponData?.coupon_code_id || null,
        };

        if (HOTEL_DETECTED) {
          window.location = ApiService.createHotelCheckoutSession(payload);

          setIsStepProcessing(false);
        } else {
          const sessionRes = await ApiService.createCheckoutSession(payload);
          if (sessionRes.ok) {
            const sessionData = await sessionRes.json();
            window.location = sessionData.url;
            //goNextStep(e);
            // setIsStepProcessing(false);
          } else {
            console.log("Failed to create session");
            alert("Sorry, we are unable to process your request at this time.");
            setIsStepProcessing(false);
          }
        }
      } catch (err) {
        console.error("Failed to create session", err);
        setIsStepProcessing(false);
      }
    } else {
      goNextStep(navigate);
    }
  };

  // Email Checker Function
  const checkMemberExist = (params) => {
    let valid;
    let error;
    let message;
    setMemberStatus(false);

    if (inputFields) {
      ApiService.memberStatus(params, locationDatas.emailCheck)
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.errorMessage) {
              valid = false;
              error = true;
              message = languages.validateEmailCheck
                ? languages.validateEmailCheck
                : "Something went wrong. Please try again.";
            } else if (
              result &&
              result.status_text &&
              (result.status_text === "MEMBER-Current Member" ||
                result.status_text === "MEMBER-In Progress")
            ) {
              valid = false;
              error = true;
              message = languages.emailCurrentlyBeingProcessMessage
                ? languages.emailCurrentlyBeingProcessMessage
                : "The email is in use by an existing member. Please login to continue or contact Member Services for further assistance.";
            } else {
              if (
                result.status_text === "MEMBER-Lapsed Member" ||
                result.status_text === "MEMBER-Pending Member" ||
                !result.memberid
              ) {
              }
              valid = true;
              error = false;
              message = "";
            }

            if (inputFields) {
              setInputFields((prevState) => {
                return prevState.map((field) => {
                  // Check if the current field is the one you want to update
                  if (field.name === "email") {
                    return {
                      ...field,
                      checking: false,
                      valid: valid,
                      message: message,
                      isError: error,
                    };
                  }
                  return field;
                });
              });
              setEmailChecking(false);
              setMemberId(result.memberid);
            }
            setTouched(false);
            setMemberStatus(true);
          },
          () => {
            setMemberStatus(false);
          },
        );
    }
  };



  var isCountryIndiaPrimary;

  if (locationDatas.country === "in" || locationDatas.country === "IN") {
    isCountryIndiaPrimary = inputFields;
  } else {
    isCountryIndiaPrimary = inputFields.filter((x) => x.name !== "tax_number");
  }

  // [Primary] - Input state changes
  function inputChange(e) {
    var inputName = e.target.name;
    var inputValue = e.target.value;
    if (inputName === "postal_code") {
      inputValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    }
    let storedData = isCountryIndiaPrimary.map((inputFields) => {
      if (inputFields.name === inputName) {
        return {
          ...inputFields,
          value: inputValue,
        };
      } else {
        return {
          ...inputFields,
        };
      }
    });

    // setInputFields(storedData)
    setInputLanguages(setInputFields, storedData, languages);
    setTouched(true);
  }

  function inputPhoneChange(inputVal, name) {
    var dialCode = name.dialCode;
    var localNumber = inputVal.startsWith(dialCode)
      ? inputVal.slice(dialCode.length)
      : inputVal;
    var countryCodeValLeading0 = localNumber.replace(/^0+/, "") || "0";
    var leahNum = dialCode + countryCodeValLeading0;
    var phoneNum = inputVal.startsWith("+") ? inputVal : `+${inputVal}`;
    var validatedPhoneNum = phone(phoneNum, {
      strictDetection: true,
      validateMobilePrefix: false,
    });

    const phoneObj = {
      ...validatedPhoneNum,
      localNumber, // ex. 045 XXX XXXX
      countryCodeValLeading0, // ex. 45 XXX XXXX'
      leahNum, // ex. 61 45 XXX XXXX
      dialCode, // ex. 61
      inputVal,
    };

    let storedData = isCountryIndiaPrimary.map((inputFields) => {
      if (inputFields.name === "phone_number") {
        if (
          !phoneObj.isValid || // Check if phone validation failed
          isNaN(Number(phoneObj.countryCodeValLeading0)) ||
          inputVal.length < 10
        ) {
          return {
            ...inputFields,
            value: phoneObj,
            valid: false,
            isError: true,
            message: languages.validatePhone
              ? languages.validatePhone
              : "This field must contain a valid phone number",
          };
        } else {
          return {
            ...inputFields,
            value: phoneObj,
            valid: true,
            isError: false,
            message: "",
          };
        }
      } else {
        return {
          ...inputFields,
        };
      }
    });

    // setInputFields(storedData)
    setInputLanguages(
      setInputFields,
      storedData,
      languages,
      "input phone change",
    );
  }

  // ADDRESS [STEP]
  // STEP
  // PRIMARY
  const googleOptions = {
    fields: ["address_components", "geometry", "icon", "name"],
    types: ["address"],
  };

  console.log("loadingCheck", { isLoaded, isProductLoaded, hasAttemptedLoad });

  if (!isLoaded) {
    return <LoadingScreen />;
  } else if (loadError) {
    return <ErrorComponent membership="Accorplus Membership" errorID={loadError} />
  } else {
    return (
      <>
        {/* Static Step 1  */}
        <HashRouter>
          <Routes>
            <Route
              path=""
              index
              element={
                <StepContainer
                  stepNum={1}
                  setStep={setStep}
                  productError={productError}
                  progress={progress}
                  onCloseModal={onCloseModal}
                  languages={languages}
                >
                  <ProductStep
                    currentStep={step}
                    languages={languages}
                    locationData={locationDatas}
                    products={products}
                    selectMembership={selectMembership}
                    isProductLoaded={isProductLoaded}
                    isProductLoading={isProductLoading}
                    error={productError}
                    locationDataCurrency={locationDataCurrency}
                    stepNo={1}
                    couponObj={couponData}
                    isUserLogged={isUserLogged}
                    businessCategories={businessCategories}
                    benefitsTranslations={benefitsTranslations}
                    refundWidgetToggle={false}
                    isProcessing={isProcessing}
                    full={true}
                    goNextStep={storeMembershipData}
                    isDisabled={
                      products.filter((x) => x.isSelected === true).length === 0
                        ? true
                        : false
                    }
                  />
                </StepContainer>
              }
            />
            <Route
              path="qbr"
              element={
                <StepContainer
                  stepNum={1}
                  setStep={setStep}
                  productError={productError}
                  progress={progress}
                  onCloseModal={onCloseModal}
                  languages={languages}
                >
                  <QbrEligibilityStep
                    currentStep={step}
                    validateQbr={validateQbr}
                    QBRinput={QBRinput}
                    isQBRError={isQBRError}
                    QBRmessage={QBRmessage}
                    showQBRTerms={showQBRTerms}
                    inputQBREligibilityEl={inputQBREligibilityEl}
                    checkBoxConsentQBR={checkBoxConsentQBR}
                    checkBoxTermsQBR={checkBoxTermsQBR}
                    checkBoxContactInfoQBR={checkBoxContactInfoQBR}
                    handleCheckBoxConsentQBR={handleCheckBoxConsentQBR}
                    handleCheckBoxTermsQBR={handleCheckBoxTermsQBR}
                    handleCheckBoxContactInfoQBR={handleCheckBoxContactInfoQBR}
                    inputQBRChange={inputQBRChange}
                    showCheckBoxTermsTermsError={showCheckBoxTermsTermsError}
                    languages={languages}
                    locationData={locationDatas}
                    goNextStep={goNextStep}
                    stepNo={10}
                    isQbr={isQbr}
                    goPreviousStep={goPreviousStep}
                    reviewLoading={reviewLoading} // [Step] - Review
                    QBRLoading={QBRLoading}
                    confirmValidateQBR={confirmValidateQBR}
                  />
                </StepContainer>
              }
            />
            <Route
              path="details"
              element={
                <StepContainer
                  stepNum={2}
                  setStep={setStep}
                  productError={productError}
                  progress={progress}
                  onCloseModal={onCloseModal}
                  languages={languages}
                >
                  <PersonalDetailStep
                    currentStep={step}
                    languages={languages}
                    locationData={locationDatas}
                    checkMemberExist={checkMemberExist}
                    onFieldBlur={onFieldBlur}
                    inputChange={inputChange}
                    inputPhoneChange={inputPhoneChange}
                    inputPersonalEl={inputPersonalEl}
                    salutationOverride={salutationOverride}
                    isStepProcessing={isStepProcessing}
                    taxNumberIN={true}
                    inputFields={isCountryIndiaPrimary}
                    stepNo={2}
                    emailChecking={emailChecking}
                    // inputFields           = {inputFields}
                    goPreviousStep={goPreviousStep}
                    isProcessing={isProcessing}
                    full={true}
                    goNextStep={personalDetailsSubmit}
                    isDisabled={!memberStatus}
                    products={products}
                    localStorageDatas={localStorageDatas}
                    couponObj={couponData}
                    translationKey={translationKey}
                    personalDetailsSubmit={personalDetailsSubmit}
                    setInputFields={setInputFields}
                    setStep={setStep}
                    setIsPrimaryPostalRequired={setIsPrimaryPostalRequired}
                    handleOnUpdateAddress={handleOnUpdateAddress}
                  />
                </StepContainer>
              }
            />
            {/* <AddressStep 
                          currentStep                = {step}
                          languages                  = {languages}
                          locationData               = {locationDatas}
                          goNextStep                 = {goNextStep}
                          findMyaddessInGoogle       = {findMyaddessInGoogle}
                          primaryAddressInput        = {primaryAddressInput}
                          primaryBillingAddressInput = {primaryBillingAddressInput}
                          addressFind                = {addressFind}
                          inputAddressEl             = {inputAddressEl}
                          inputAddressBillingEl      = {inputAddressBillingEl}
                          inputFields                = {primaryAddressInputFields}
                          handleCardCheckBox         = {handleCardCheckBox}
                          isPrimaryDigitalCard       = {isPrimaryDigitalCard}
                          billingAddress             = {primaryBillingAddressInputFields}
                          onSubmitAddressDetails     = {onSubmitAddressDetails}
                          handleCheckboxAddress      = {handleCheckboxAddress}
                          localStorageDatas          = {localStorageDatas}
                          checkboxAddress            = {checkboxAddress}
                          inputRef                   = {inputRef}
                          stepNo                     = {5}
                          options                    = {googleOptions}
                          autoCompleteRef            = {autoCompleteRef}
                          googleAddressEmpty         = {googleAddressEmpty}
                        /> */}
            <Route
              path="review"
              element={
                <StepContainer
                  stepNum={3}
                  setStep={setStep}
                  productError={productError}
                  progress={progress}
                  onCloseModal={onCloseModal}
                  languages={languages}
                >
                  <ReviewStep
                    currentStep={step}
                    languages={languages}
                    locationData={locationDatas}
                    localStorageDatas={localStorageDatas}
                    goNextStep={goNextStep}
                    editReview={editReview}
                    // termsLink={TERMS_CONDITIONS_LINK}
                    checkBoxTerms={checkBoxTerms}
                    readMeTerms={readMeTerms}
                    handleCheckBoxTerms={handleCheckBoxTerms}
                    handleNextStep={handleNextStep}
                    checkboxError={checkboxError}
                    handleCardCheckBox={handleCardCheckBox}
                    isRenewalPage={false}
                    isExpress={false} // only for express-checkout
                    handleShowList={handleShowList}
                    inputPromoEl={inputPromoEl}
                    memberId={memberId}
                    removeProduct={removeProduct}
                    // isSecondaryMember   = {isSecondaryMember}
                    stepNo={3}
                    memberCreationError={memberCreationError}
                    couponObj={couponData}
                    isUserLogged={isUserLogged}
                    businessCategories={businessCategories}
                    goPreviousStep={goPreviousStep}
                    confirmOrder={confirmOrder}
                    reviewLoading={reviewLoading}
                  // termsLink={TERMS_CONDITIONS_LINK}
                  // cardCheckBox={cardCheckBox}
                  />
                </StepContainer>
              }
            />
            <Route
              path="payment"
              element={
                <StepContainer
                  stepNum={4}
                  setStep={setStep}
                  productError={productError}
                  progress={progress}
                  onCloseModal={onCloseModal}
                  languages={languages}
                >
                  <PaymentStep
                    currentStep={step}
                    languages={languages}
                    locationData={locationDatas}
                    localStorageDatas={localStorageDatas}
                    goNextStep={processPayment}
                    stepNo={4}
                    isRenewalPage={false}
                    couponObj={couponData}
                    isUserLogged={isUserLogged}
                    subsidiary={subsidiary}
                    category="registration"
                    businesscategory={queryParams.get("bc")}
                    businessCategories={businessCategories}
                    goPreviousStep={goPreviousStep}
                  />
                </StepContainer>
              }
            />
            <Route
              path="confirmation"
              element={
                <StepContainer
                  stepNum={5}
                  setStep={setStep}
                  productError={productError}
                  progress={progress}
                  onCloseModal={onCloseModal}
                  languages={languages}
                >
                  <ConfirmationStep
                    currentStep={step}
                    languages={languages}
                    locationData={locationDatas}
                    localStorageDatas={localStorageDatas}
                    isRenewalPage={false}
                    goNextStep={goNextStep}
                    stepNo={5}
                    isQBR={Helper.isQbr(locationDatas)}
                    // termsLink={TERMS_CONDITIONS_LINK}
                    category="registration"
                    couponObj={couponData}
                    isUserLogged={isUserLogged}
                    businessCategories={businessCategories}
                  />
                </StepContainer>
              }
            />

            <Route
              path="explore"
              element={
                <StepContainer
                  stepNum={11}
                  setStep={setStep}
                  productError={productError}
                  progress={progress}
                  onCloseModal={onCloseModal}
                  languages={languages}
                >
                  <ExploreStep
                    languages={languages}
                    currentStep={step}
                    isQBR={Helper.isQbr(locationDatas)}
                    isRenewalPage={false}
                    localStorageDatas={localStorageDatas}
                    goNextStep={goNextStep}
                    stepNo={11}
                  />
                </StepContainer>
              }
            />

            <Route exact path="payment" element={<Payment />} />
            <Route
              exact
              path="renewals"
              element={<Renewal baseUrl={baseUrl} isLogged={true} />}
            />
            <Route
              path="express-checkout"
              element={<ExpressCheckout baseUrl={baseUrl} isLogged={true} />}
            />
            <Route path="login" element={<Login />} />
            <Route path="registration" element={<Register />} />
            <Route path="transaction" element={<Transaction />} />
            <Route path="callback" element={<OAuthCallback />} />
          </Routes>
        </HashRouter>
      </>
    );
  }
};
export default App;
